import { createStore } from 'vuex'

import auth from '../modules/auth/store'
import usermo from '../modules/daybook/store'

const store = createStore({
  modules: {
      usermo,
      auth
  }
})




export default store